<!-- eslint-disable -->
<template lang="pug">
    .progress-bar
        .progress-bar__block
            .row.progress-bar__info
                .col-xs-6.col-sm-6.progress-bar__info-left
                    span
                        | {{ $i18n.t('battle.battle_youEarnedIt') }}
                    .progress-bar__text-with-icon_big
                        | {{ this.numberOfStars }}
                        svg-icon(name="star-fill" aria-hidden="true" height="18px" width="18px")
                //.col-xs-6.col-sm-6.progress-bar__info-right
                    div
                        .progress-bar__first-line
                            span
                                | {{ $i18n.t('battle.battle_gamesWith') }}
                            .progress-bar__text-with-icon_small
                                | {{ 2 }}х&nbsp;
                                svg-icon(name="star-fill" aria-hidden="true" height="18px" width="18px")
                        span.progress-bar__second-line
                            //todo: user.battles.gamesWith2xStars
                            .text__big
                                | {{ 10 }}&nbsp;
                            .text__small
                                | {{ $i18n.t('battle.battle_outOf', {stars: 10}) }}
            .progress-bar__scale-block
                .progress-bar__pointer(:style="currentLeftIndentOfPointer")
                    svg-icon(name="pointer" aria-hidden="true" size="x-large")
                .progress-bar__scale-background
                .progress-bar__scale_active(:style="currentWidthOfActiveScale")
                .progress-bar__values
                    .progress-bar__value(
                        v-for="item in sizesForScale"
                        :key="item.value + Math.random()"
                        :style="{'left': item.percent * 100 + '%'}"
                    )
                        .progress-bar__point(
                            :class="{'progress-bar__point_active': item.value <= numberOfStars}"
                        )
                        .progress-bar__number
                            |  {{ item.value }}
            cs-button.progress-bar__button(v-if="user.type !== 'student'" color="blue")
                | {{ $i18n.t('battle.battle_achievements_buyGamesWithTwoXStars') }}
</template>

<script>
    /*eslint-disable*/
    import { mapState } from "vuex";

    export default {
        props: {
            numberOfStars: {
                type: Number,
                default: 0
            }
        },
        data() {
            return {
                arrayOfNumbers: [],
                arrayOfWidthParameters: [],
                sizesForScale: []
            }
        },
        mounted() {
            this.calcIntermediateValues(this.numberOfStars)
        },
        methods: {
            calcIntermediateValues(value) {
                let maxScaleNumber = 0;
                if (value < 50) {
                    maxScaleNumber = 50;
                } else if (value < 100) {
                    maxScaleNumber = 100;
                } else {
                    maxScaleNumber = value * 1.33;
                }
                let intermediateNumberInPercent = 0.075;
                for (let h = 0; h < 13; h++) {
                    if (h === 0) {
                        this.sizesForScale.push({percent: 0.05});
                    } else {
                        this.sizesForScale.push({percent: Number((0.05 + intermediateNumberInPercent * h).toFixed(3))})
                    }
                }
                this.sizesForScale.forEach((obj) => {
                    obj.value = Math.round(obj.percent * maxScaleNumber);
                })
            }
        },
        computed: {
            ...mapState({
                user: state => state.auth.user,
            }),
            currentWidthOfActiveScale() {
                if (this.numberOfStars < 50) {
                    return 'width: ' + (this.numberOfStars / 50) * 100 + '%';
                } else if (this.numberOfStars < 100) {
                    return 'width: ' + this.numberOfStars +'%';
                } else {
                    return 'width: ' + this.numberOfStars / (this.numberOfStars * 1.33) * 100 + '%'
                }
            },
            currentLeftIndentOfPointer() {
                if (this.sizesForScale.find( obj => obj.value === this.numberOfStars) && this.sizesForScale) {
                    return 'left: ' + this.sizesForScale.find( obj => obj.value === this.numberOfStars).percent * 100 + '%'
                }
                if (this.numberOfStars < 50) {
                    return 'left: ' + (this.numberOfStars / 50) * 100 + '%'
                }
                if (this.numberOfStars < 100) {
                    return 'left: ' + this.numberOfStars + '%'
                }
                if (this.numberOfStars >= 100) {
                    return 'left: ' + this.numberOfStars / (this.numberOfStars * 1.33) * 100 + '%'
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .progress-bar {
        padding: 30px 10px;
        width: 100%;
        background-color: $hsl-color-gray-98;
        box-sizing: border-box;
        border-radius: $border-radius-20;
        @include stack-space($space-large);
        @include media($md) {
            padding: 30px 20px;
        }
        @include media($xlg) {
            padding: 30px 40px;
        }
        @include media($xl) {
            padding: 30px 10%;
        }
    }

    .progress-bar__block {
        height: 100%;
        width: 100%;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        align-items: center;
        @include media($xl) {
            padding: 0 50px;
        }
    }

    .progress-bar__info {
        width: 100%;
    }

    .progress-bar__info-left {
        text-align: left;
    }

    .progress-bar__info-right {
        text-align: right;
        display: flex;
        justify-content: flex-end;
    }

    .progress-bar__text-with-icon_big {
        font-size: 32px;
        font-weight: 500;
        display: flex;
        .svg-icon {
            padding: 12px 0 0 5px;
        }
    }

    .progress-bar__text-with-icon_small {
        display: flex;
        font-weight: 500;
    }

    .progress-bar__first-line, .progress-bar__second-line {
        display: flex;
        align-items: flex-end;
        justify-content: center;
        span {
            white-space: pre;
        }
    }

    .progress-bar__second-line {
        font-weight: 500;
    }

    .text__big {
        height: 32px;
        font-size: 32px;
    }

    .progress-bar__scale-block {
        display: flex;
        width: 100%;
        padding: 50px 8px;
        position: relative;
        @include stack-space($space-large);
    }

    .progress-bar__pointer {
        position: absolute;
        top: 15px;
        margin-left: -6px;
    }

    .progress-bar__scale-background {
        width: 100%;
        height: 8px;
        background-color: $hsl-color-gray-94;
        border-radius: $border-radius-20;
    }

    .progress-bar__scale_active {
        position: absolute;
        height: 8px;
        background-color: $hsl-color-yellow-66;
        border-radius: $border-radius-20;
    }

    .progress-bar__values {
        position: absolute;
        left: 0;
        top: 49px;
        display: flex;
        width: 100%;
        justify-content: space-around;
        padding-left: 8px;
        @include media($md) {
            top: 45px;
        }
    }

    .progress-bar__value {
        height: 35px;
        display: flex;
        flex-direction: column;;
        align-items: center;
        justify-content: space-between;
        position: absolute;
        @include media($md) {
            height: 50px;
        }
    }

    .progress-bar__point {
        height: 10px;
        width: 10px;
        border-radius: 50%;
        border: 2px solid $hsl-color-gray-82;
        background-color: $x-color-white;
        @include media($md) {
            height: 17px;
            width: 17px;
        }
    }

    .progress-bar__number {
        font-size: 10px;
        @include media($md) {
            font-size: 14px;
        }
    }

    .progress-bar__point_active {
        border: 2px solid $x-color-white;
        background-color: $hsl-color-yellow-66;
    }

    .progress-bar__button {
        font-weight: 500 !important;
        width: 275px;
        @include media($md) {
            width: 300px;
        }
    }
</style>
